import {
  CLEAR_AUTH_ERROR,
  CONFIRM_USER_REGISTRATION_FAIL,
  CONFIRM_USER_REGISTRATION_START,
  CONFIRM_USER_REGISTRATION_SUCCESS,
  MOBILE_USER_LOGIN_FAIL,
  MOBILE_USER_LOGIN_START,
  MOBILE_USER_LOGIN_SUCCESS,
  MOBILE_USER_REGISTRATION_FAIL,
  MOBILE_USER_REGISTRATION_START,
  MOBILE_USER_REGISTRATION_SUCCESS,
  RESTORE_MOBILE_FAIL,
  RESTORE_MOBILE_START,
  RESTORE_MOBILE_SUCCESS,
} from './constants';

const initialState = {
  isLoading: false,
  isError: false,
  userData: null,
  restoreResult: null,
  registerResult: null,
  error: null,
  timer: 60,
  codeLength: null,
};

export default (state = initialState, { type, response }) => {
  switch (type) {
    case RESTORE_MOBILE_START:
      return {
        ...state,
        isLoading: true,
        isError: false,
        restoreResult: null,
        error: null,
      };

    case MOBILE_USER_LOGIN_START:
      return {
        ...state,
        isLoading: true,
        isError: false,
        userData: null,
        error: null,
      };

    case MOBILE_USER_REGISTRATION_START:
    case CONFIRM_USER_REGISTRATION_START:
      return {
        ...state,
        isLoading: true,
        isError: false,
        registerResult: null,
        error: null,
      };

    case MOBILE_USER_LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        userData: response,
        timer: response.timer,
        codeLength: response.codeLength,
      };

    case MOBILE_USER_REGISTRATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        registerResult: response,
        timer: response?.timer,
        codeLength: response.codeLength,
      };

    case CONFIRM_USER_REGISTRATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        registerResult: response,
      };

    case RESTORE_MOBILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        restoreResult: response,
        timer: response.timer,
        codeLength: response.codeLength,
      };

    case MOBILE_USER_LOGIN_FAIL:
    case MOBILE_USER_REGISTRATION_FAIL:
    case RESTORE_MOBILE_FAIL:
    case CONFIRM_USER_REGISTRATION_FAIL:
      return { ...state, isError: true, isLoading: false, error: response };

    case CLEAR_AUTH_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};
